/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { createOrUpdateAlbumCollectionModelSchema } from "../createOrUpdateAlbumCollectionModelSchema.ts";
import { guidCreatedOrUpdatedEntityModelSchema } from "../guidCreatedOrUpdatedEntityModelSchema.ts";
import { z } from "zod";

export const putApiAlbumCollectionsIdPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор выпуска")
    })

/**
 * @description Идентификатор обновляемого выпуска
 */
export const putApiAlbumCollectionsId200Schema = z.lazy(() => guidCreatedOrUpdatedEntityModelSchema)

/**
 * @description Ошибка валидации | Выпуск уже существует
 */
export const putApiAlbumCollectionsId400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const putApiAlbumCollectionsId401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const putApiAlbumCollectionsId403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Выпуск не найден
 */
export const putApiAlbumCollectionsId404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const putApiAlbumCollectionsId500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса
 */
export const putApiAlbumCollectionsIdMutationRequestSchema = z.lazy(() => createOrUpdateAlbumCollectionModelSchema).describe("Тело запроса")

export const putApiAlbumCollectionsIdMutationResponseSchema = z.lazy(() => putApiAlbumCollectionsId200Schema)